// extracted by mini-css-extract-plugin
module.exports = {"error":"error___WB1B2"};